import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { toast } from 'react-toastify';
import { syncCache, type CacheSyncSource } from './api';

const SOURCE_LABEL: Record<CacheSyncSource, string> = {
  'market-price': 'Market Prices',
  'news-article': 'News Articles',
};

function describeError(err: unknown, fallback: string): string {
  if (isAxiosError(err)) {
    const data = err.response?.data as
      | { message?: string | string[]; error?: string }
      | undefined;
    const msg = data?.message;
    if (Array.isArray(msg)) return msg.join(', ');
    if (typeof msg === 'string' && msg.length > 0) return msg;
    if (data?.error) return data.error;
  }
  return fallback;
}

export function useCacheSync(source: CacheSyncSource) {
  return useMutation({
    mutationFn: () => syncCache(source),
    onSuccess: () => {
      toast.success(`${SOURCE_LABEL[source]} sync completed successfully`);
    },
    onError: (err) => {
      toast.error(describeError(err, 'Sync failed. Please try again.'));
    },
  });
}
